<template>
  <div class="w-full">
    <div class="flex w-full items-center justify-between bg-s-50">
      <div
        class="px-4"
        data-testid="mobile-burger-menu"
        @click="manageMenuMobileClick"
      >
        <IconCloseMenu
          v-if="$modal.getModal('mobileMenu')"
          class="size-6 cursor-pointer"
          data-testid="menu-mobile-close-icon"
        />
        <IconHamburgerMenu
          v-else
          class="size-6 cursor-pointer"
          data-testid="menu-mobile-icon"
        />
      </div>
      <NuxtLink to="/" class="py-3 pr-4" external no-prefetch>
        <IconBenchmarkLogo class="h-5 w-[8.625rem]" />
      </NuxtLink>

      <div class="flex">
        <a
          class="cursor-pointer flex items-center bg-grey-200 px-4 py-3 text-xs font-semibold"
          :href="portalUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          Portal
        </a>
        <button
          v-if="!authenticated"
          class="cursor-pointer bg-p-100 px-4 py-3 text-xs font-semibold"
          @click="$modal.open('login')"
        >
          Sign In
        </button>
        <div
          v-else
          class="relative flex cursor-pointer select-none items-center justify-end px-4 py-3"
          @click="manageMobileAccountClick"
        >
          <IconUser
            class="h-6 w-6"
            :class="[isImpersonating ? 'text-charts-navy-200' : 'text-p-600']"
          />

          <!-- Mobile Account Menu -->
          <transition
            name="slide-down"
            enter-from-class="opacity-0 -translate-y-2"
            enter-active-class="transition-all duration-200"
            leave-active-class="transition-all duration-150"
            leave-to-class="opacity-0 -translate-y-2"
          >
            <div
              v-if="$modal.getModal('mobileAccountMenu')"
              class="absolute top-full right-0 z-50 mt-1 flex w-52 flex-col bg-white text-grey-900 text-sm font-semibold shadow-lg border border-s-200 rounded-md overflow-hidden"
            >
              <NuxtLink
                to="/account"
                class="block px-4 py-3 hover:bg-s-100 border-b border-s-200"
                @click="$modal.close('mobileAccountMenu')"
              >
                Account Details
              </NuxtLink>

              <button
                v-if="isImpersonating"
                class="block px-4 py-3 text-left hover:bg-s-100 border-b border-s-200"
                @click="restoreOriginalSession"
              >
                Stop impersonation session
              </button>

              <button
                class="block px-4 py-3 text-left hover:bg-s-100"
                @click="logout"
              >
                Log Out
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div>
      <NavigationMobileMenu
        :open="$modal.getModal('mobileMenu')"
        :menu="itemsMenu"
        modal-name="mobileMenu"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useScreenSize } from '~/composables/useScreenSize'

import NavigationMobileMenu from '~/components/navigation/MobileMenu.vue'
import IconBenchmarkLogo from '~/assets/icons/benchmark-logo-black.svg'
import IconCloseMenu from '~/assets/icons/close.svg'
import IconHamburgerMenu from '~/assets/icons/hamburger.svg'
import IconUser from '~/assets/icons/user.svg'
import { SOURCE_NAVIGATION } from '~/constants/navigation'
import { useWwwNavigation } from '~/composables/useWwwNavigation'

const { $auth, $modal } = useNuxtApp()
const router = useRouter()
const authStore = useAuthStore()
const { isNotDesktop } = useScreenSize()
const { portalUrl } = useRuntimeConfig().public

const authenticated = computed(() => authStore.authenticated)

const { WWW_MOBILE_NAVIGATION } = useWwwNavigation()

const itemsMenu = [
  ...WWW_MOBILE_NAVIGATION,
  {
    name: 'Source',
    groups: SOURCE_NAVIGATION,
  },
]

const manageMenuMobileClick = () => {
  if ($modal.getModal('mobileMenu')) {
    $modal.close('mobileMenu')
    document.body.classList.remove('overflow-hidden')
  } else {
    document.body.classList.add('overflow-hidden')
    $modal.open('mobileMenu')
    $modal.close('mobileAccountMenu')
  }
}
const manageMobileAccountClick = () => {
  if ($modal.getModal('mobileAccountMenu')) {
    $modal.close('mobileAccountMenu')
  } else {
    $modal.open('mobileAccountMenu')
    $modal.close('mobileMenu')
  }
}

const restoreOriginalSession = () => {
  $auth.restoreOriginalSession()
  window.location.href = '/'
}

const logout = async () => {
  await $auth.logout()
  await router.push('/')
}

watch(isNotDesktop, (value) => {
  if (!value) {
    $modal.close('mobileMenu')
    $modal.close('mobileAccountMenu')
  }
})

const isImpersonating = computed(() => {
  return $auth.isImpersonating()
})
</script>
